<template lang="pug">

  v-dialog(v-model="dialog" persistent :max-width="width")

    .dialogHeader

      .dialogHeaderTitle {{ title }}

      .dialogHeaderClose
        .dialogCloseButton.mdi.mdi-close(@click="close(closeWithAction ? selectedContent : false)")

    .dialogBody

      .dialogBodyContent(v-html="text")

      .dialogCheckbox(v-if="!!selectedContent === true && !!selectedContent.cdCheckbox === true")
        sos-checkbox(id="checkbox" :label="selectedContent.cdCheckboxLabel" :checked="checkboxChecked" @click="onCheckboxClick" class="sosCheckbox--consent")

      .dialogPasswordField(v-if="!!selectedContent === true && !!selectedContent.cdPassword === true")
        span.dialogPasswordIconArea
          v-icon(size="22").cdPasswordIcon mdi-lock
        span.dialogPasswordFieldArea
          input(v-model="defaultPassword" maxlength="64").cdPasswordField

      .cdPasswordError(v-if="!!error === true") {{ error }}

    .dialogFooter(:class="{ 'text-right': buttonPosition === 'right', 'text-center': buttonPosition === 'center', 'text-left': buttonPosition === 'left' }")
        sos-button(@buttonClick="close(closeWithAction ? selectedContent : false)" size="medium" color="blue" :buttonLabel="args.closeText || 'Fechar'" buttonIcon="" buttonIconSize="16" :class="{ 'mr-3': isConfirm }")
        sos-button(v-if="isConfirm" @buttonClick="close(selectedContent)" size="medium" color="danger" :buttonLabel="args.continueText || 'Continuar'" buttonIcon="mdi-check-outline" buttonIconSize="16" :disabled="!!selectedContent === true && !!selectedContent.cdCheckbox === true && checkboxChecked === false")

</template>

<script>

  import SosButton from '@/components/SosButton'
  import SosCheckbox from '@/components/SosCheckbox'

  export default {
    name: 'ConfirmDialog',
    components: {
      'sos-button': SosButton,
      'sos-checkbox': SosCheckbox,
    },
    props: {
      buttonPosition: {
        type: String,
        default: () => 'right',
      },
      title: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
      width: {
        type: Number,
        default: () => 330,
      },
    },
    data () {
      return {
        checkboxChecked: false,

        args: {
          // title: '',
          // text: '',
          // type: '',
          // data: null,
          // isResponse: false,
          // buttonPosition: 'right',
          // width: 330,
          closeText: 'Fechar',
          continueText: 'Continuar',
        },
        dialog: false,
        isConfirm: false,
        selectedContent: false,
        closeWithAction: false,

        error: '',
        defaultPassword: '',
      }
    },

    /* computed: {
    }, */

    /* watch: {
      dialog: {
        // the callback will be called immediately after the start of the observation
        immediate: true,
        handler (newDialog, oldDialog) {
          if (newDialog === true) {
            //
          } else {
            this.clear()
          }
        },
      },
    }, */

    methods: {
      close (confirmed = false) {
        if (!!confirmed === true && !!confirmed.cdPassword === true && confirmed.cdPassword !== this.defaultPassword) {
          this.error = 'Senha incorreta'
          return false
        }

        if (confirmed.callback) {
          confirmed.callback()
        }

        this.checkboxChecked = false
        this.error = ''
        this.defaultPassword = ''

        this.dialog = false

        this.$emit('close', confirmed)
      },

      open (selectedContent, confirm = true, closeWithAction = false) {
        // this.dialog = true

        this.isConfirm = confirm
        this.selectedContent = selectedContent
        this.closeWithAction = closeWithAction

        this.checkboxChecked = false
        this.error = ''
        this.defaultPassword = ''

        this.args = {
          // title: '',
          // text: '',
          // type: '',
          // data: null,
          // isResponse: false,
          // buttonPosition: 'right',
          // width: 330,
          closeText: !!selectedContent.args === true && !!selectedContent.args.closeText === true ? selectedContent.args.closeText : 'Fechar',
          continueText: !!selectedContent.args === true && !!selectedContent.args.continueText === true ? selectedContent.args.continueText : 'Continuar',
        }

        this.dialog = true
      },

      onCheckboxClick () {
        this.checkboxChecked = !this.checkboxChecked
      },
    },
  }

</script>

<style lang="scss" scoped>

  .dialogCheckbox {
    margin-top: 25px;
  }

  .dialogPasswordField {
    margin-top: 10px;
    padding: 5px 5px 5px 10px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 7px;
    box-shadow: inset 2px 2px 0px 0px rgba(0, 0, 0, 0.1);

    font-size: 0;
  }

  .dialogPasswordIconArea,
  .dialogPasswordFieldArea {
    display: inline-block;
    vertical-align: middle;
  }

  .dialogPasswordIconArea {
    width: 10%;
    padding-right: 10px;

    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
  }

  .dialogPasswordFieldArea {
    position: relative;
    width: 90%;
    padding-left: 15px;
    border-left: 1px solid rgba(0, 0, 0, 0.3);
  }

  .cdPasswordIcon {
    color: steelblue !important;
  }

  .cdPasswordField {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 30px;
    outline: 0;
    border: 0;

    // color: steelblue;
    color: #656565;
    font-size: 16px;
    line-height: 30px;

    &::placeholder {
      // color: rgba(70, 130, 180, 0.7);
      color: rgb(101, 101, 101, 0.7);
    }
  }

  .cdPasswordError {
    margin-top: 5px;
    margin-bottom: 0;

    color: orangered;
    font-weight: 600;
    font-size: 15px;
    line-height: 1.5;
  }

  @media (max-width: 600px)
  {
    .dialogPasswordIconArea,
    .dialogPasswordFieldArea {
      vertical-align: top;
    }

    .dialogPasswordIconArea {
      width: 100%;
    }

    .dialogPasswordFieldArea {
      width: 100%;
      padding-left: 0;
      border-left: 0;
    }
  }

</style>
